export const WEAK = 'weak';
export const MEDIUM = 'medium';
export const STRONG = 'strong';
export const EMPTY = 'empty';

export const SUPPORT_EMAIL = 'hello@techunited.co';
export const DASHBOARD_SUPPORT_EMAIL = 'dashboard@techunited.co';
